import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=cb5c9b72&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5c9b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb5c9b72')) {
      api.createRecord('cb5c9b72', component.options)
    } else {
      api.reload('cb5c9b72', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=cb5c9b72&scoped=true&", function () {
      api.rerender('cb5c9b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RvuKlSpKx80Z/JS/comp/SearchFilterTokens.vue"
export default component.exports